import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-root',
  templateUrl: './Poker.MainView.html'
})

export class MainComponent implements OnInit {

  title = "Poker Game";
  constructor() { }

  ngOnInit() {
  }
}
